import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styles from './ImageCaption.module.css'

export default function ImageCaption() {
  const { t } = useTranslation()
  const { lang = 'en' } = useParams<{ lang: string }>()

  return (
    <figcaption className={styles.caption}>
      <span className={styles.captionText}>{t('image_caption_text')}</span>
      <Link
        to={`/faq/${lang}#ai-generated-images`}
        className={styles.infoLink}
        aria-label={t('image_caption_info_aria')}
        onClick={e => e.stopPropagation()}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={styles.infoIcon}>
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </Link>
    </figcaption>
  )
}
